import { DownloadBlob } from '@browser/Browser';
import * as rt from "@common/AppRT";
import { generateName, strCompareLowerCase } from '@common/Common';
import GoalNavigation from "@common/Components/GoalNavigation.vue";
import PortfolioNavigation from "@common/Components/PortfolioNavigation.vue";
import { ICommandStatus } from '@cqrs/cqrs';
import { ICriteriaCommand } from '@Criteria/cqrs';
import { ChangeDefaultWeightsSetCommandV1 } from '@Criteria/Hierarchies/Domain/commands-core';
import CriteriaHierarchyCommands from '@Criteria/Hierarchies/Domain/commands-vue-component';
import CriteriaHierarchyQueries from '@Criteria/Hierarchies/Domain/queries-vue-component';
import WeightsComparerDialog from '@Criteria/Weights/Components/WeightsComparerDialog.vue';
import { WeightsSetDeleterViewModel } from "@Criteria/Weights/Components/WeightsSetDeleter";
import WeightsSetDeleter from '@Criteria/Weights/Components/WeightsSetDeleter.vue';
import { WeightsSetDependenciesViewerViewModel } from "@Criteria/Weights/Components/WeightsSetDependenciesViewer";
import WeightsSetDependenciesViewer from "@Criteria/Weights/Components/WeightsSetDependenciesViewer.vue";
import { WeightsSetEditorCreateWeightsSetEventPayload, WeightsSetEditorNormalizeWeightsEventPayload, WeightsSetEditorUpdateWeightsSetEventPayload, WeightsSetEditorViewModel } from "@Criteria/Weights/Components/WeightsSetEditor";
import WeightsSetEditor from "@Criteria/Weights/Components/WeightsSetEditor.vue";
import WeightsViewerDialog from '@Criteria/Weights/Components/WeightsViewerDialog.vue';
import { CreateWeightsSetCommandV1, DeleteWeightsSetCommandV1, ExportAllWeightsToXlsCommandV1, ExportWeightsToXlsFromSurveyVotesCommandV1, ExportWeightsToXlsFromWeightsSetCommandV1, UpdateWeightsSetCommandV1 } from '@Criteria/Weights/Domain/commands-core';
import CriteriaWeightsCommands from '@Criteria/Weights/Domain/commands-vue-component';
import CriteriaWeightsQueries from "@Criteria/Weights/Domain/queries-vue-component";
import { SurveyReadModel, WeightsComparerReadModel, WeightsPageReadModel, WeightsReadModel, WeightsSetDependenciesReadModel, WeightsSetEditorReadModel, WeightsSetReadModel, WeightsViewerReadModel } from '@Criteria/Weights/Domain/readmodels';
import { CriteriaSurveyAccessLinksViewModel } from "@Evaluation/CriteriaSurveys/Components/CriteriaSurveyAccessLinks";
import CriteriaSurveyAccessLinks from "@Evaluation/CriteriaSurveys/Components/CriteriaSurveyAccessLinks.vue";
import { CriteriaSurveyEmailSenderViewModel } from "@Evaluation/CriteriaSurveys/Components/CriteriaSurveyEmailSender";
import CriteriaSurveyEmailSender from "@Evaluation/CriteriaSurveys/Components/CriteriaSurveyEmailSender.vue";
import { SubSurveysManagerDialogViewModel } from "@Evaluation/CriteriaSurveys/Components/SubSurveysManagerDialog";
import SubSurveysManagerDialog from '@Evaluation/CriteriaSurveys/Components/SubSurveysManagerDialog.vue';
import SurveyCloserDialog from '@Evaluation/CriteriaSurveys/Components/SurveyCloserDialog.vue';
import { SurveyEditorDialogViewModel } from "@Evaluation/CriteriaSurveys/Components/SurveyEditorDialog";
import SurveyEditorDialog from '@Evaluation/CriteriaSurveys/Components/SurveyEditorDialog.vue';
import SurveyOpenerDialog from '@Evaluation/CriteriaSurveys/Components/SurveyOpenerDialog.vue';
import { ChangeSubSurveyVoteStrengthCommandV1, CreateSurveyCommandV1, DeleteSurveyCommandV1, ExcludeSubSurveyCommandV1, IncludeSubSurveyCommandV1, SendEmailCommandV1, StartSurveyCommandV1, StopSurveyCommandV1, UpdateSurveyCommandV1 } from '@Evaluation/CriteriaSurveys/Domain/commands-core';
import CriteriaSurveyCommands from '@Evaluation/CriteriaSurveys/Domain/commands-vue-component';
import CriteriaSurveysQueries from '@Evaluation/CriteriaSurveys/Domain/queries-vue-component';
import { CriteriaDownloadAccessLinksReadModel, CriteriaSurveyPanelistsReadModel, CriteriaSurveyReadModel, DownloadVotesReadModel, SubSurveysManagerReadModel } from '@Evaluation/CriteriaSurveys/Domain/readmodels';
import moment from "moment";
import Component, { mixins } from 'vue-class-component';

@Component({
    components: {
        GoalNavigation, PortfolioNavigation, SurveyEditorDialog, SubSurveysManagerDialog, SurveyOpenerDialog, SurveyCloserDialog, WeightsComparerDialog, WeightsSetDeleter, WeightsViewerDialog,
        CriteriaSurveyAccessLinks, CriteriaSurveyEmailSender, WeightsSetEditor, WeightsSetDependenciesViewer
    }
})
export default class WeightsPage extends mixins(CriteriaHierarchyQueries, CriteriaHierarchyCommands, CriteriaWeightsQueries,
    CriteriaSurveysQueries, CriteriaSurveyCommands, CriteriaWeightsCommands)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get projectId() { return Number.parseInt(this.$route.params.projectId); }
    get evalModelId() { return Number.parseInt(this.$route.params.evalModelId); }

    rm: WeightsPageReadModel = null;
    get criteriaHierarchyId(): number { return this.rm.CriteriaHierarchyId; }
    get defaultWeightsSetId() { return this.rm.DefaultWeightsSetId; }
    get surveysView() { return this.rm.Surveys.sort((a, b) => strCompareLowerCase(a.Name, b.Name)); }
    get weightsSetsView(): WeightsSetReadModel[] { return this.rm.WeightsSets; }
    get selectedWeightsSets(): WeightsSetReadModel[] { return this.rm.WeightsSets.filter(a => a.IsSelected); }

    surveyEditorDialog = new SurveyEditorDialogViewModel();
    subSurveysManagerDialog = new SubSurveysManagerDialogViewModel();

    surveyOpenerSurveyId: number | null = null;
    surveyCloserSurveyId: number | null = null;

    weightsComparer: WeightsComparerReadModel = null;
    weightsComparerOpened: boolean = false;

    weightsViewer: WeightsViewerReadModel = null;
    weightsViewerOpened: boolean = false;

    criteriaSurveyAccessLinks = new CriteriaSurveyAccessLinksViewModel();
    criteriaSurveyEmailSender = new CriteriaSurveyEmailSenderViewModel();
    weightsSetEditor = new WeightsSetEditorViewModel();
    weightsSetDependenciesViewer = new WeightsSetDependenciesViewerViewModel();
    weightsSetDeleter = new WeightsSetDeleterViewModel();


    formatDate(date: Date | null)
    {
        if (date == null) return null;
        return moment(date).format('MMM D, YYYY')
    }

    formatTime(date: Date | null)
    {
        if (date == null) return null;
        return moment(date).format('LT');
    }


    showSurveyCreator()
    {
        this.surveyEditorDialog.showCreator(generateName("Survey"));
    }

    showSurveyEditor(surveyId: number)
    {
        const s = this.rm.Surveys.find(a => a.Id === surveyId);
        this.surveyEditorDialog.showEditor(s.Id, s.Name, s.Description, s.ResponseDueDate);
    }

    showSurveyDeleter(surveyId: number)
    {
        const s = this.rm.Surveys.find(a => a.Id === surveyId);

        if (confirm(`Do you want to delete ${s.Name}?`))
        {
            this.handleDeleteSurveyCommand(surveyId);
        }
    }

    showSubSurveysManager(surveyId: number)
    {
        const s = this.rm.Surveys.find(a => a.Id === surveyId);
        this.subSurveysManagerDialog.show(s.Id, s.Name);
        this.runSubSurveysManagerQueryV1(this.workspaceId, this.projectId, this.evalModelId, s.Id);
    }

    showAccessLinks(surveyId: number)
    {
        this.runCriteriaAccessLinksBySurveyIdQueryV1(this.workspaceId, surveyId);
        this.criteriaSurveyAccessLinks.show(surveyId);
    }

    showSurveyOpener(surveyId: number)
    {
        this.surveyOpenerSurveyId = surveyId;
    }

    showSurveyCloser(surveyId: number)
    {
        this.surveyCloserSurveyId = surveyId;
    }

    showSurveyWeightsViewer(surveyId: number)
    {
        this.weightsViewer = null;
        this.weightsViewerOpened = true;
        this.runSurveyWeightsViewerQueryV1(this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    showSurveyWeightsComparer(surveyId: number)
    {
        this.weightsComparer = null;
        this.weightsComparerOpened = true;
        this.runSurveyWeightsComparerQueryV1(this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    showWeightsSetsWeightsComparer()
    {
        if (this.selectedWeightsSets.length > 0)
        {
            this.weightsComparer = null;
            this.weightsComparerOpened = true;
            this.runWeightsSetsComparerQueryV1(this.workspaceId, this.projectId, this.evalModelId, this.selectedWeightsSets.map(a => a.Id));
        }
    }

    showSurveyWeightsSetCreator(s: SurveyReadModel)
    {
        this.weightsSetEditor.showCreator(`Panel: ${s.Name}`);
        this.runSurveyWeightsSetCreatorQueryV1(this.workspaceId, s.Id);
    }

    showWeightsSetCreator()
    {
        this.weightsSetEditor.showCreator(generateName("Weights"));
        this.runWeightsSetEditorQueryV1(this.workspaceId, this.rm.CriteriaHierarchyId, null);
    }

    showWeightsSetEditor(ws: WeightsSetReadModel)
    {
        this.weightsSetEditor.showEditor(ws.Id, ws.Name);
        this.runWeightsSetEditorQueryV1(this.workspaceId, this.rm.CriteriaHierarchyId, ws.Id);
    }

    showWeightsSetWeightsViewer(wsId: number)
    {
        this.weightsViewer = null;
        this.weightsViewerOpened = true;
        this.runWeightsSetWeightsViewerQueryV1(this.workspaceId, this.projectId, wsId);
    }

    showWeightsSetDependencies(ws: WeightsSetReadModel)
    {
        this.weightsSetDependenciesViewer.show(ws.Id, ws.Name);
        this.runWeightsSetDependenciesQueryV1(this.workspaceId, ws.Id);
    }

    showWeightsSetDeleter(ws: WeightsSetReadModel)
    {
        this.weightsSetDeleter.show(ws.Id, ws.Name);
        this.runWeightsSetDependenciesQueryV1(this.workspaceId, ws.Id);
    }

    showCriteriaSurveyEmailSender(surveyId: number, ids: number[])
    {
        this.criteriaSurveyEmailSender.show(surveyId, ids);
    }



    DownloadVotesCommand()
    {
        this.runVotesExportByEvalModelIdQueryV1(this.workspaceId, this.evalModelId);
    }

    handleNormalizeWeights(data: WeightsSetEditorNormalizeWeightsEventPayload)
    {
        this.runNormalizedWeightsQueryV1(this.workspaceId, this.criteriaHierarchyId, data.weights);
    }

    handleDownloadAccessLinks(surveyId: number)
    {
        this.runExportAccessLinksBySurveyIdQueryV1(this.workspaceId, surveyId);
    }


    handleExportWeightsToXlsFromWeightsSetCommand(wsId: number)
    {
        this.invokeExportWeightsToXlsFromWeightsSetCommandV1(this.workspaceId, this.projectId, this.criteriaHierarchyId, wsId);
    }

    handleExportWeightsToXlsFromSurveyVotesCommand(surveyId: number)
    {
        this.invokeExportWeightsToXlsFromSurveyVotesCommandV1(this.workspaceId, this.projectId, this.criteriaHierarchyId, this.evalModelId, surveyId);
    }

    handleExportAllWeightsToXlsCommand()
    {
        this.invokeExportAllWeightsToXlsCommandV1(this.workspaceId, this.projectId, this.rm.CriteriaHierarchyId, this.evalModelId);
    }

    handleSendEmailCommand(emailSubject: string, emailBody: string)
    {
        const sender = this.criteriaSurveyEmailSender;
        this.invokeSendEmailCommandV1(this.workspaceId, sender.surveyId, sender.projectUserIds, emailSubject, emailBody);
    }


    handleStopSurveyCommand(surveyId: number) 
    {
        this.invokeStopSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    handleStartSurveyCommand(surveyId: number) 
    {
        this.invokeStartSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }


    handleDeleteWeightsSetCommand(wsId: number)
    {
        this.invokeDeleteWeightsSetCommandV1(this.workspaceId, this.rm.CriteriaHierarchyId, wsId);
    }

    handleChangeDefaultWeightsSetCommand(wsId: number)
    {
        this.invokeChangeDefaultWeightsSetCommandV1(this.workspaceId, this.rm.CriteriaHierarchyId, this.rm.DefaultWeightsSetId, wsId);
    }

    handleDeleteSurveyCommand(surveyId: number)
    {
        this.invokeDeleteSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId);
    }

    handleCreateSurveyCommand(surveyId: number, name: string, description: string, responseDueDate: string | null)
    {
        this.invokeCreateSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId, name, description, responseDueDate);
    }

    handleUpdateSurveyCommand(surveyId: number, name: string, description: string, responseDueDate: string | null)
    {
        this.invokeUpdateSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, surveyId, name, description, responseDueDate);
    }


    handleIncludeSubSurveyCommand(masterSurveyId: number, subSurveyId: number, voteStrength: number)
    {
        this.invokeIncludeSubSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, masterSurveyId, subSurveyId, voteStrength);
    }

    handleChangeSubSurveyVoteStrengthCommand(masterSurveyId: number, subSurveyId: number, voteStrength: number)
    {
        this.invokeChangeSubSurveyVoteStrengthCommandV1(this.workspaceId, this.projectId, this.evalModelId, masterSurveyId, subSurveyId, voteStrength);
    }

    handleExcludeSubSurveyCommand(masterSurveyId: number, subSurveyId: number)
    {
        this.invokeExcludeSubSurveyCommandV1(this.workspaceId, this.projectId, this.evalModelId, masterSurveyId, subSurveyId);
    }

    handleCreateWeightsSetCommand(data: WeightsSetEditorCreateWeightsSetEventPayload)
    {
        this.invokeCreateWeightsSetCommandV1(this.workspaceId, this.criteriaHierarchyId, data.name, data.weights);
    }

    handleUpdateWeightsSetCommand(data: WeightsSetEditorUpdateWeightsSetEventPayload)
    {
        this.invokeUpdateWeightsSetCommandV1(this.workspaceId, this.criteriaHierarchyId, data.weightsSetId, data.name, data.weights);
    }


    mounted()
    {
        document.title = "Weights | TransparentChoice";
        this.runWeightsPageQueryV1(this.workspaceId, this.projectId, this.evalModelId);
    }

    onSetModel(model: any, modelName: string)
    {
        if (modelName === "WeightsPageReadModel")
        {
            this.rm = model as WeightsPageReadModel;
        }
        else if (modelName === "CriteriaSurveyReadModel")
        {
            const rm = model as CriteriaSurveyReadModel;
            this.rm.Surveys = this.rm.Surveys.filter(a => a.Id !== rm.Id);
            this.rm.Surveys.push(rm);

            this.surveyEditorDialog.close();
        }
        else if (modelName === "SubSurveysManagerReadModel")
        {
            const rm = model as SubSurveysManagerReadModel;
            this.subSurveysManagerDialog.setData(rm);
        }
        else if (modelName === "WeightsSetEditorReadModel")
        {
            const rm = model as WeightsSetEditorReadModel;
            this.weightsSetEditor.setData(rm);
        }
        else if (modelName === "WeightsSetReadModel")
        {
            const rm = model as WeightsSetReadModel;
            this.rm.WeightsSets = this.rm.WeightsSets.filter(a => a.Id !== rm.Id);
            this.rm.WeightsSets.push(rm);
        }
        else if (modelName === "WeightsSetDependenciesReadModel")
        {
            const rm = model as WeightsSetDependenciesReadModel;
            this.weightsSetDeleter.setData(rm);
            this.weightsSetDependenciesViewer.setData(rm);
        }
        else if (modelName === "DownloadVotesReadModel")
        {
            const rm = model as DownloadVotesReadModel;
            DownloadBlob(rm.Url);
        }
        else if (modelName === "WeightsComparerReadModel")
        {
            this.weightsComparer = model as WeightsComparerReadModel;
        }
        else if (modelName === "WeightsViewerReadModel")
        {
            this.weightsViewer = model as WeightsViewerReadModel;
        }
        else if (modelName == "CriteriaSurveyPanelistsReadModel")
        {
            const rm = model as CriteriaSurveyPanelistsReadModel;
            this.criteriaSurveyAccessLinks.setData(rm);
        }
        else if (modelName === "CriteriaDownloadAccessLinksReadModel")
        {
            const rm = model as CriteriaDownloadAccessLinksReadModel;
            DownloadBlob(rm.Url);
        }
        else if (modelName === "WeightsReadModel")
        {
            const rm = model as WeightsReadModel;
            this.weightsSetEditor.setRecalculatedWeights(rm);
        }
    }

    onCommandSucceed(cmd: ICriteriaCommand, correlationId: string, result: any)
    {
        if (ChangeDefaultWeightsSetCommandV1.matchType(cmd))
        {
            this.rm.DefaultWeightsSetId = Number.parseInt(correlationId);
        }
        else if (DeleteWeightsSetCommandV1.matchType(cmd))
        {
            this.rm.WeightsSets = this.rm.WeightsSets.filter(a => a.Id !== Number.parseInt(correlationId));
            this.weightsSetDeleter.close();
        }
        else if (CreateWeightsSetCommandV1.matchType(cmd))
        {
            this.runWeightsSetQueryV1(this.workspaceId, this.rm.CriteriaHierarchyId, Number(result));
            this.weightsSetEditor.close();
        }
        else if (UpdateWeightsSetCommandV1.matchType(cmd))
        {
            const cwsId = Number.parseInt(correlationId);
            this.runWeightsSetQueryV1(this.workspaceId, this.rm.CriteriaHierarchyId, cwsId);
            this.weightsSetEditor.close();
        }
        else if (CreateSurveyCommandV1.matchType(cmd))
        {
            this.runCriteriaSurveyQueryV1(this.workspaceId, this.projectId, this.evalModelId, Number(result));
        }
        else if (UpdateSurveyCommandV1.matchType(cmd))
        {
            this.runCriteriaSurveyQueryV1(this.workspaceId, this.projectId, this.evalModelId, Number(correlationId));
        }
        else if (DeleteSurveyCommandV1.matchType(cmd))
        {
            this.rm.Surveys = this.rm.Surveys.filter(a => a.Id !== Number.parseInt(correlationId));
            this.surveyEditorDialog.close();
        }
        else if (IncludeSubSurveyCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as IncludeSubSurveyCommandV1;

            this.rm.Surveys.find(s => s.Id == Number.parseInt(cmd1.Id)).SubSurveysCount++;
            this.subSurveysManagerDialog.includeSubSurvey(Number(correlationId), cmd1.VoteStrength);
        }
        else if (ExcludeSubSurveyCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as ExcludeSubSurveyCommandV1;

            this.rm.Surveys.find(s => s.Id == Number.parseInt(cmd1.Id)).SubSurveysCount--;
            this.subSurveysManagerDialog.excludeSubSurvey(Number(correlationId));
        }
        else if (ChangeSubSurveyVoteStrengthCommandV1.matchType(cmd))
        {
            const cmd1 = cmd as ChangeSubSurveyVoteStrengthCommandV1;

            this.subSurveysManagerDialog.changeSubSurveyVoteStrength(Number(correlationId), cmd1.VoteStrength);
        }
        else if (StartSurveyCommandV1.matchType(cmd))
        {
            const surveyId = Number(correlationId);

            this.rm.Surveys.find(s => s.Id === surveyId).SurveyStarted = true;

            rt.send("CriteriaSurveys.HostWorkflow", "SurveyStarted",
                {
                    SurveyId: surveyId,
                    WorkspaceId: this.workspaceId
                });

            this.surveyOpenerSurveyId = null;

        }
        else if (StopSurveyCommandV1.matchType(cmd))
        {
            const surveyId = Number(correlationId);

            this.rm.Surveys.find(s => s.Id == Number(correlationId)).SurveyStarted = false;

            rt.send("CriteriaSurveys.HostWorkflow", "SurveyStopped",
                {
                    SurveyId: surveyId,
                    WorkspaceId: this.workspaceId
                });

            this.surveyCloserSurveyId = null;
        }
        else if (ExportAllWeightsToXlsCommandV1.matchType(cmd) ||
            ExportWeightsToXlsFromWeightsSetCommandV1.matchType(cmd) ||
            ExportWeightsToXlsFromSurveyVotesCommandV1.matchType(cmd))
        {
            location.href = result;
        }
        else if (SendEmailCommandV1.matchType(cmd))
        {
            alert("Sent");
            this.criteriaSurveyEmailSender.close();
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreateSurveyCommandV1.matchType(status.Command))
        {
            this.surveyEditorDialog.displayValidationErrors(status.ValidationErrors);
        }
        else if (UpdateSurveyCommandV1.matchType(status.Command))
        {
            this.surveyEditorDialog.displayValidationErrors(status.ValidationErrors);
        }
        else if (IncludeSubSurveyCommandV1.matchType(status.Command))
        {
            alert(status.Error);
        }
        else if (CreateWeightsSetCommandV1.matchType(status.Command))
        {
            this.weightsSetEditor.displayValidationErrors(status.ValidationErrors);
        }
        else if (UpdateWeightsSetCommandV1.matchType(status.Command))
        {
            this.weightsSetEditor.displayValidationErrors(status.ValidationErrors);
        }
    }
}
